import React, { FC, useState } from "react";
import { FaCheck } from "react-icons/fa";

import { SettingsConfirmModal } from "../../../../components/modal/SettingsConfirmModal";
import { WorkDetailsModel } from "../../../../factories/work/model/work-details.model";
import { CatchMeUp } from "../../../ai/CatchMeUp";
import { WorkBillingCard } from "./widgets/work-billing/WorkBillingCard";
import { WorkDetails } from "./widgets/work-details/WorkDetails";
import { WorkNotesChat } from "./widgets/work-notes/WorkNotesChat";
import { WorkTasks } from "./widgets/work-tasks/WorkTasks";

type Props = {
  work: WorkDetailsModel;
};

export const WorkDetailsView: FC<Props> = ({ work }) => {
  const [isOpenMessage, setIsOpenMessage] = useState(false);
  return (
    <div className={"relative"}>
      <div
        className={
          "grid grid-cols-[1fr_2fr_1fr] items-start gap-6 max-md:grid-cols-1"
        }>
        <div className={"max-md:min-w-0"}>
          <WorkDetails work={work} setIsOpenMessage={setIsOpenMessage} />
          {/* Invoices for this work item; only for people with billing access. */}
          <WorkBillingCard work={work} />
        </div>
        <div className={"min-w-0"}>
          {/* AI summary; hidden unless the firm switched AI on. */}
          <CatchMeUp workId={work.id} />
          <WorkTasks work={work} />
        </div>
        {/* Notes work like a chat; files live in the Files tab (Roadmap 1823). */}
        <div className={"sticky top-4 min-w-0 max-md:static"}>
          <WorkNotesChat />
        </div>
      </div>
      {isOpenMessage && (
        <SettingsConfirmModal
          onClose={() => setIsOpenMessage(false)}
          onConfirm={() => setIsOpenMessage(false)}
          icon={<FaCheck />}
          noCancel
          title={"Creating a new recurring work"}
          description={
            "It may take <b>up to 5 minutes</b> for new work items to appear.<br />All recurring work can be found in the <b>Repeats</b> tab."
          }
          confirmText={"Ok"}
          variant={"primary"}
        />
      )}
    </div>
  );
};
